import React, { useId, useState } from 'react';
import Icon from './Icon';

// One question or fact that opens in place. A real button with aria-expanded, so Enter, Space
// and screen readers all work.
function Accordion({ title, detail, defaultOpen = false, dark = false, headingLevel: Heading = 'h3', mono = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();
  const rule = dark ? 'border-limestone/20' : 'border-wall/20';

  return (
    <div className={`border-b ${rule}`}>
      <Heading className="m-0 font-sans text-[17px]">
        <button
          type="button"
          aria-expanded={open}
          aria-controls={panelId}
          onClick={() => setOpen((v) => !v)}
          className={`flex min-h-[56px] w-full items-center justify-between gap-6 py-4 text-left font-medium transition-colors ${
            dark ? 'hover:text-bronze-light' : 'hover:text-bronze-deep'
          } ${mono ? 'font-mono text-[14px]' : ''}`}
        >
          {title}
          <Icon name={open ? 'minus' : 'plus'} size={18} />
        </button>
      </Heading>
      <div id={panelId} hidden={!open} className="swap-in pb-5 pr-10">
        <p className={`type-body ${dark ? 'text-glass-light' : 'text-glass'}`}>{detail}</p>
      </div>
    </div>
  );
}

export default Accordion;
